

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "£{{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};



function btm_bnr(){
  setTimeout(() => {
    if(document.querySelector('.template-product') && document.querySelector('.product-info') && document.querySelector('.media-slider')){
      if(document.querySelector('.product-info').offsetHeight > document.querySelector('.media-slider').offsetHeight){
        document.querySelector('.product-wrap').classList.add('active-btm-bnr');
      }else{
        document.querySelector('.product-wrap').classList.remove('active-btm-bnr');
      }
    }
  },300);
}
btm_bnr();

function fetchConfig(contentType) {
    const config = {
        method: 'POST', // Or GET, PUT, etc.
        headers: {
            'Accept': 'application/json',
            // Add any other default headers
        },
    };
    if (contentType) {
        switch (contentType) {
            case 'json':
                config.headers['Content-Type'] = 'application/json'
                break;
            case 'javascript':
                config.headers['Content-Type'] = 'application/javascript'
                break;
        }
    }
    return config;
}
/*if(document.querySelector('.product-addcart')){
  document.querySelector('.product-addcart').addEventListener('click',function(evt){
    evt.preventDefault();
    let variant_id = evt.target.closest('form').querySelector('input[name="id"]').getAttribute('value');
    let qty = evt.target.closest('form').querySelector('.quantity__input').value;
    let formData = {
      'items': [{
        'id': variant_id,
        'quantity': qty
      }]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
    .then((response) => response.json())
    .then((response) => {      
      if (response.status) {
        document.querySelector('.product-form-error').innerHTML = response.description;
        setTimeout(function(e){
          document.querySelector('.product-form-error').innerHTML  = '';
        },2000);
        return;
      }else{
        if(typeof load_cart == 'function'){
          load_cart();
          setTimeout(function(e){
            document.querySelector('body').classList.add('open-drawer');
          },500);
        }else{
          window.location.href = "/cart";
        }
      }
    })
    .catch((e) => {console.error(e);})
    .finally(() => {});
  });
}*/

document.addEventListener('DOMContentLoaded', function(){
  // if (window.innerWidth < 992) {
  var splide = new Splide(".media-nav", {
    pagination: false,
    perPage: 1,
    perMove: 1,
    arrows: false
  });
    
    function checkWidth() {
        if (window.innerWidth > 991) {
            splide.destroy(); // Destroy Splide if width > 991px
        } else {
            if (!splide.state.is(Splide.STATES.MOUNTED)) {
                splide.mount(); // Remount if width is <= 991px
            }
        }
    }
    
  splide.mount();
  window.addEventListener('resize', checkWidth);
    checkWidth();
  // }
  
});


/* -- Recipient Form -- */

if(document.querySelectorAll('.product-addcart')) document.querySelectorAll('.product-addcart').forEach((productAddCart) => {
  productAddCart.addEventListener('click',function(evt){
    evt.preventDefault();
    productAddCart.classList.add('addingCart');
    if(document.querySelector('.recipient-form-wrapper')){
      let form = evt.target.closest("form");
      let product = {
        'name': document.querySelector('.recipient-row input[name="properties[recipient_name]"]').value,
        'date': document.querySelector('.recipient-row input[name="properties[send_date]"]').value,
        'email': document.querySelector('.recipient-row input[name="properties[recipient_email]"]').value,
        'msg': document.querySelector('.recipient-row textarea[name="properties[Message]"]').value,
      };
      console.log('product', product)
      let payload = {
        id: form.querySelector('input[name="id"]').value,
        quantity: 1,
        properties: product
      };
      //console.log('payload', payload)
      
      setTimeout(function() {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4 && xhr.status === 200) {
            let response = JSON.parse(xhr.responseText);
            if (typeof load_cart == 'function') {
              load_cart();
              setTimeout(function(e){
                document.querySelector('body').classList.add('open-drawer');
              },500);
            } else {
              window.location.href = "/cart";
            }
          }
        };
        xhr.send(JSON.stringify(payload));
      }, 1000);
    }else{
        
            const productContainer = this.closest('.snippet-addto-cart'); // Adjust selector if needed
            if (!productContainer) {
              console.error("Product container not found.");
              return;
            }
        
            const quantityInput = productContainer.querySelector('.quantity__input');
            if (!quantityInput) {
              console.error("Quantity input not found in product container.");
              return;
            }
        
            const quantity = parseInt(quantityInput.value, 10);
            if (isNaN(quantity) || quantity <= 0) {
              console.error("Invalid quantity value.");
              return;
            }
        
            const variantId = productContainer.querySelector('input[name="id"]').value;
            if (!variantId) {
              console.error("Variant ID not found.");
              return;
            }
        
            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', quantity);
        
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;
            config.method = 'POST';
        
            fetch(routes.cart_add_url, config)
              .then(response => response.json())
              .then(response => {
                if (response.status) {
                  document.querySelector('.product-form-error').innerHTML = response.description;
                  setTimeout(() => {
                    document.querySelector('.product-form-error').innerHTML = '';
                  }, 2000);
                  return;
                } else {
                  if (typeof load_cart === 'function') {
                    load_cart();
                    setTimeout(() => {
                      document.body.classList.add('open-drawer');
                    }, 500);
                  } else {
                    window.location.href = "/cart";
                  }
                }
              })
              .catch(error => {
                console.error("Error adding product to cart:", error);
              });
          

      // ======================
      // const config = fetchConfig('javascript');
      // config.headers['X-Requested-With'] = 'XMLHttpRequest';
      // delete config.headers['Content-Type'];
      // var cartform = document.querySelector('.product-addcart').closest('form');
      // const formData = new FormData(cartform);
      // config.body = formData;
      // fetch(`${routes.cart_add_url}`, config)
      // .then((response) => response.json())
      // .then((response) => {
      //   if (response.status) {
      //     document.querySelector('.product-form-error').innerHTML = response.description;
      //     setTimeout(function(e){
      //       document.querySelector('.product-form-error').innerHTML  = '';
      //     },2000);
      //     return;
      //   }else{
      //     if(typeof load_cart == 'function'){
      //       load_cart();
      //         setTimeout(function(e){
      //           document.querySelector('body').classList.add('open-drawer');
      //         },500);
      //     }else{
      //       window.location.href = "/cart";
      //     }
      //   }
      // })
      // .catch((e) => {
      //   console.error(e);
      // })
      // .finally(() => {
    
      // });
      // =================
    }
  });
})


/* -- VariantRadios  -- */

class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    document.querySelectorAll('.sticky-product-variant li').forEach((stickyVariant) => {
      let val = (stickyVariant.getAttribute('data-val')).toLowerCase();
      if(val == (this.currentVariant.title).toLowerCase()){
        document.querySelectorAll('.sticky-product-variant li').forEach((stickyVariantRmv) => {
          stickyVariantRmv.classList.remove('active');
        });
        stickyVariant.classList.add('active');
      }
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      document.querySelectorAll('.choose-cart').forEach(function(chooseCart){
        chooseCart.classList.remove('hide-selectore-button');
      });
      document.querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.add('hide-selectore-button');
      });     
    }else{
      document.querySelectorAll('.choose-cart').forEach(function(chooseCart){
        chooseCart.classList.add('hide-selectore-button');
      });
      document.querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.remove('hide-selectore-button');
      });
    }   
  }
  
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      //const price = this.currentVariant.price
      //console.log(this.currentVariant.price, 'currentVariant')
     if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span.p-add-cart-btn');
    if(this.currentVariant != undefined){
      if(this.currentVariant.available){
        document.querySelectorAll(".choose-cart").forEach(function(chooseCart){
          chooseCart.classList.remove('variant_sold-out');
        });
      }else{
        document.querySelectorAll(".choose-cart").forEach(function(chooseCart){
          chooseCart.classList.add('variant_sold-out');
        });
      }
    }
    if(!addButton) return;
     if(disable){
      addButton.setAttribute('disabled', 'disabled');
      if(text) addButtonText.textContent = text;
    }else {
      addButton.removeAttribute('disabled');
      //if(addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
      if(addButtonText) addButtonText.innerHTML = `<span>${window.variantStrings.addToCart}</span><span>— ${Shopify.formatMoney(this.currentVariant.price)}</span>`;
    }
    if(!modifyClass) return;
  }
  setUnavailable(){
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span.p-add-cart-btn');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if(!addButton) return;
    if(addButtonText) addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData(){
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
          });
        });
      });
    });
  }
}

if (document.querySelector(".read-more span")){
  document.querySelectorAll(".read-more span").forEach(function (btn) {
    btn.addEventListener("click", function (event) {
    
      event.preventDefault(); 
      
      let description = this.closest(".product__description");
      let longDesc = description.querySelector(".long-desc");

      if (longDesc.style.maxHeight) {
        longDesc.style.maxHeight = null; 
        longDesc.style.opacity = "0";
        btn.textContent = "More";
      } else {
        longDesc.style.maxHeight = longDesc.scrollHeight + "px";
        longDesc.style.opacity = "1";
        btn.textContent = "Less";
      }
    });
  });
}

  // function addReviewSpan(target) {
  //   // Check if span already exists to avoid duplicates
  //   if (!target.querySelector('.custom-review-span')) {
  //     const span = document.createElement('span');
  //     span.className = 'custom-review-span'; // optional for styling
  //     span.textContent = 'Review';
  //     target.appendChild(span);
  //   }
  // }

  // document.addEventListener('DOMContentLoaded', function () {
  //   const reviewDiv = document.querySelector('.junip-product-summary-review-count');

  //   if (reviewDiv) {
  //     addReviewSpan(reviewDiv);

  //     const observer = new MutationObserver(() => {
  //       addReviewSpan(reviewDiv);
  //     });

  //     observer.observe(reviewDiv, {
  //       childList: true,
  //       subtree: true
  //     });
  //   }
  // });
// ------------------------

//  function ft(t) {
//                 if (t.classList.contains("product-quantity-input")) {
//                     var e = t.getAttribute("data-variant")
//                       , n = t.value
//                       , r = t.getAttribute("data-price")
//                       , i = document.querySelector('.product-quantity-price[data-variant="' + e + '"]');
//                     if (i) {
//                         var o = r * n
//                           , s = new Intl.NumberFormat("en-US",{
//                             style: "currency",
//                             currency: "USD"
//                         });
//                         i.innerText = s.format(o / 100)
//                     }
//                 }
//             }



// document.querySelectorAll(".number-quantity-container:not(.initialized)").forEach((function(t) {
//     var e = t.querySelector("input")
//       , n = t.querySelector(".increase-quantity")
//       , r = t.querySelector(".decrease-quantity");
//     n.addEventListener("click", (function() {
//       console.log("click------------");
//         e.value = parseInt(e.value ? e.value : 0) + 1,
//         ft(e)
//     }
//     )),
//     r.addEventListener("click", (function() {
//         parseInt(e.value) - 1 >= parseInt(e.getAttribute("min")) && (e.value = parseInt(e.value) - 1,
//         ft(e))
//     }
//     )),
//     e.addEventListener("keydown", (function(t) {
//         return t.preventDefault(),
//         e.blur(),
//         !1
//     }
//     )),
//     e.addEventListener("click", (function(t) {
//         e.blur()
//     }
//     )),
//     t.classList.add("initialized")
// }
// ))

//  var r = document.querySelectorAll(".variant-form");

// function ct({ method, url, data }) {
//     return fetch(url, {
//         method: method,
//         body: data,
//         headers: {
//             'Accept': 'application/json'
//         }
//     }).then(response => response.json());
// }


//  r.forEach((function(t) {
//       t.addEventListener("submit", (function(e) {
//           e.preventDefault(),
//           ct({
//               method: "post",
//               url: "/cart/add.js",
//               data: new FormData(t)
//           }).then((function(t) {
//              load_cart();
//             setTimeout(function(e){
//               document.querySelector('body').classList.add('open-drawer');
//             },500);
//           }
//           )).catch((function(t) {
//               console.log(t)
//           }
//           ))
//       }
//       ))
//   }
//   ))

// // customElements.define('skio-plan-picker', SkioPlanPickerComponent);


// const variantWraps = document.querySelectorAll('.variant_wrap');
// const input = document.querySelector('input[name="id"]');
// const variantForms = document.querySelectorAll('.variant-form');

// variantWraps.forEach(variantWrap => {
//   const radios = variantWrap.querySelectorAll('input[type="radio"]');
//   radios.forEach(radio => {
//     radio.addEventListener('change', function(event) {
//       if (this.checked) {
//         setTimeout(function(){
//           const selectedVariant = radio.getAttribute('data-variant');
//           const inputValue = parseInt(input.value);
//           console.log('inputValue', inputValue); 

//           variantForms.forEach(variantForm => {
//             const formVariant = parseInt(variantForm.getAttribute('data-variant'));
            

//             if(inputValue == formVariant){
//               variantForm.classList.add('block');
//               variantForm.classList.remove('hidden');
//             }else{
//               variantForm.classList.remove('block');
//               variantForm.classList.add('hidden');
//             }
            
//           });
          
//         }, 100);
//       }
//     });
//   });
// });





// =============
const vs = document.querySelectorAll(".variant-select");
const vf = document.querySelectorAll(".variant-form");

vs.forEach(function(selectElement) {
    selectElement.addEventListener("click", function() {
        const variantId = selectElement.getAttribute("data-variant");
        const matchingForm = document.querySelector(`.variant-form[data-variant="${variantId}"]`);

        if (matchingForm) {
            vf.forEach(function(form) {
                form.classList.add("hidden");
            });

            matchingForm.classList.remove("hidden");

            setTimeout(function() {
                window.Afterpay.init(window.Afterpay.jQuery_3_4_1);
            }, 250);
        }
    });
});
// ===============
// Function to update price based on quantity
function ft(t) {
  console.log("producttttttttttttt");
    if (t.classList.contains("product-quantity-input")) {
        var e = t.getAttribute("data-variant"),
            n = t.value,
            r = t.getAttribute("data-price"),
            i = document.querySelector('.product-quantity-price[data-variant="' + e + '"]');
        if (i) {
            var o = r * n,
                s = new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD"
                });
           // i.innerText = s.format(o / 100);
         // console.log('Price', s.format(o / 100))
          i.setAttribute("proquan-price", s.format(o / 100) );
        }
    }
}

// Initialize quantity controls
document.querySelectorAll(".number-quantity-container:not(.initialized)").forEach((function(t) {
    var e = t.querySelector("input"),
        n = t.querySelector(".increase-quantity"),
        r = t.querySelector(".decrease-quantity");
    n.addEventListener("click", (function() {
        e.value = parseInt(e.value ? e.value : 0) + 1,
        ft(e)
    })),
    r.addEventListener("click", (function() {
        parseInt(e.value) - 1 >= parseInt(e.getAttribute("min")) && (e.value = parseInt(e.value) - 1,
        ft(e))
    })),
    e.addEventListener("keydown", (function(t) {
        return t.preventDefault(),
        e.blur(),
        !1
    })),
    e.addEventListener("click", (function(t) {
        e.blur()
    })),
    t.classList.add("initialized")
}))

// Handle form submission
var r = document.querySelectorAll(".variant-form");

function ct({ method, url, data }) {
    return fetch(url, {
        method: method,
        body: data,
        headers: {
            'Accept': 'application/json'
        }
    }).then(response => response.json());
}

r.forEach((function(t) {
    t.addEventListener("submit", (function(e) {
        e.preventDefault();
        
        // Get the quantity input from the form being submitted
        const quantityInput = t.querySelector(".product-quantity-input");
        const quantity = quantityInput ? quantityInput.value : 1;
        
        // Create form data and set the quantity
        const formData = new FormData(t);
        formData.set('quantity', quantity);
        
        ct({
            method: "post",
            url: "/cart/add.js",
            data: formData
        }).then((function(t) {
            load_cart();
            setTimeout(function(e) {
                document.querySelector('body').classList.add('open-drawer');
            }, 500);
        })).catch((function(t) {
            console.log(t)
        }))
    }))
}))

// Handle variant selection changes
const variantWraps = document.querySelectorAll('.variant_wrap');
const input = document.querySelector('input[name="id"]');
const variantForms = document.querySelectorAll('.variant-form');

variantWraps.forEach(variantWrap => {
    const radios = variantWrap.querySelectorAll('input[type="radio"]');
    radios.forEach(radio => {
        radio.addEventListener('change', function(event) {
            if (this.checked) {
                setTimeout(function() {
                    const selectedVariant = radio.getAttribute("data-variant");
                    const inputValue = parseInt(input.value);
                    
                    variantForms.forEach(variantForm => {
                        const formVariant = parseInt(variantForm.getAttribute("data-variant").trim());
                        
                        if(inputValue == formVariant) {
                            variantForm.classList.add('block');
                            variantForm.classList.remove('hidden');
                        } else {
                            variantForm.classList.remove('block');
                            variantForm.classList.add('hidden');
                        }
                    });
                }, 100);
            }
        });
    });
});